import { useAsync } from 'react-use';
import styled from '@emotion/styled';
import { HeroImageComponent, HeroImageType } from '@model/content';
import { TestId } from '@components/test-ids';
import { BottomContainer } from '@components/common/hero/bottom/BottomContainer';
import { TitleContainer } from '@components/common/hero/title';
import { Image } from '@components/common/image';
import { getHero } from '@components/util';

const HeroImage: any = styled.div({
  width: '100vw',
  height: '50vh',
  position: 'relative'
});

export const HeroContainer = ({ images, data, destination, title, type, path }: HeroImageComponent) => {
  const { value: asyncImages } = useAsync(async () => {
    if (images || data?.images) {
      return images || data?.images;
    } else if (type === HeroImageType.STATIC_IMAGE) {
      const heroData = await getHero();
      return heroData ? heroData.images : null;
    }
  }, [path, images]);

  const heroImages = Array.isArray(images) && !!images.length ? images : asyncImages;

  if (!heroImages || !Array.isArray(heroImages) || heroImages.length === 0) {
    return null;
  }

  return (
    <HeroImage data-testid={TestId.hero}>
      <Image
        src={heroImages[0]}
        alt={title ?? 'Hero image'}
        width={1920}
        height={960}
        sizes={'100vw'}
        priority
        style={{
          objectFit: 'cover',
          width: '100%',
          height: '100%'
        }}
      />

      <BottomContainer destination={destination} />
      {title && <TitleContainer title={title} />}
    </HeroImage>
  );
};
